import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {RsvpInfoButton} from '../rsvp-info-button/rsvp-info-button'
import {ClosedRegistrationButtonProps} from './interfaces'

export const ClosedRegistrationButton: React.FC<ClosedRegistrationButtonProps> = ({
  closedRegistrationMessages,
  href,
}) => <RsvpInfoButton messages={closedRegistrationMessages} dataHook={DH.CLOSED_REGISTRATION} href={href} />
